// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VAs-","content":"styles_content__2IPni","row":"styles_row__2Uyhm","footer":"styles_footer__1I4dF","phraseLength":"styles_phraseLength__2I8y5"};